export const fullAccessRoles = [
  'administrator',
  'estimator',
  'superintendent',
  'project_coordinator',
  'operations_manager',
  'inventory_logistics',
  'billing',
];
